(function ($) {
  // Mobile menu button toggle function
  $(".mobile-menu-btn").on("click", function () {
    $(this).toggleClass("active");
  });

  // Add a overview link to each parent mobile menu item
  // $(".mex-primary-mobile-menu-container li.menu-item-has-children > a").one(
  //   "click",
  //   function () {
  //     var target = $(this);
  //     var value = target.attr("href");
  //     var element = target.parent("li");

  //     target.removeAttr("href");

  //     element
  //       .children("ul")
  //       .first("li")
  //       .prepend(
  //         '<li><a class="dropdown-item" href="' + value + '">Overview</a></li>'
  //       );
  //   }
  // );

  /**
   * Bootstrap disables parent links from opening their page, and instead displays its children.
   * This is fine for mobile menus, but we want parent links to work on desktop.
   */
  function setNavDropdownItem() {
    var windowWidth = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    var navDropdownItem = $("#main-menu-desktop").find("[data-bs-toggle]");

    // 768 = $screen-md, 992 = $screen-lg
    if (windowWidth >= 1200) {
      navDropdownItem.attr("data-bs-toggle", "massage-dropdown");
    } else {
      navDropdownItem.attr("data-bs-toggle", "dropdown");
    }
  }

  /**
   * Run the function should users resize their window.
   */
  window.addEventListener(
    "resize",
    function () {
      setNavDropdownItem();
    },
    true
  );

  setNavDropdownItem();

  // Show 'Book Now' popup modal
  $('a[href="#bookNowPopup"]').on("click", function () {
    $("#bookNowToggle").click();
  });

  // Go to chosen clinic website
  $("#goToClinicBtn").on("click", function () {
    var url = document.getElementById("clinicLocations").value;

    if (url !== "") {
      window.location = url;
    }
  });
})(jQuery);
